<div class="subject-box">
  <ng-container *ngFor="let char of chars; let i = index">
    <br *ngIf="i > 0 && i % 2 === 0">
    <span class="hanja-txt"
          [class.first]="i === 0"
          [class.selected]="char === selected">{{ char }}</span>
  </ng-container>
</div>
